import { render, staticRenderFns } from "./Input-text.vue?vue&type=template&id=460d9e1e&scoped=true"
import script from "./Input-text.vue?vue&type=script&lang=ts"
export * from "./Input-text.vue?vue&type=script&lang=ts"
import style0 from "./Input-text.vue?vue&type=style&index=0&id=460d9e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d9e1e",
  null
  
)

export default component.exports